import { DbHelper } from "@app/shared/model/db-object.model";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface CHZone {
    id: string;
    name: string;
    parents: string[];
    devices: string[];
    properties: Record<string, unknown>;
    internal: boolean;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface CHZoneData {
    UID?: string;
    Name: string;
    Parents: string[];
    Devices: string[];
    Properties: Record<string, unknown>;
    Internal: boolean;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class CHZoneHelper extends DbHelper<CHZone, CHZoneData> {
    dbTypeName = "Area";
    dbTypeNamePlural: "Areas";

    importMap: ImportMap<CHZone, CHZoneData> = [
        { i: "UID", o: "id" },
        { i: "Name", o: "name" },
        { i: "Parents", o: "parents" },
        { i: "Devices", o: "devices" },
        { i: "Properties", o: "properties" },
        { i: "Internal", o: "internal" },
    ];
}
